import type { Optional } from '@festina-life/core'
import type {
  EnumEvaluationValue,
  ModelEvaluationValue,
  SimpleEvaluationResult,
} from '@festina-life/fplus-monaco'

import type { LanguageServerInput } from '../monaco/types/monaco'
import { getFPlusLanguageServer } from '../worker/selectLanguageServer'

export const evaluateExpression = async (
  languageServerInput: Optional<LanguageServerInput>,
  errorMessageHandler: (errorMessage: string) => void,
) =>
  languageServerInput &&
  (await getFPlusLanguageServer()
    .evaluate(languageServerInput)
    .then((obj) => {
      if (obj._type === 'SimpleEvaluationResult') {
        return (obj as SimpleEvaluationResult).value
      }

      if (obj._type === 'EnumEvaluationValue') {
        const enumValue = obj as EnumEvaluationValue

        return `${enumValue.enumName}.${enumValue.literal}`
      }

      if (obj._type === 'ModelEvaluationValue') {
        return (obj as ModelEvaluationValue).json
      }
      throw Error('Unsupported value')
    })
    .catch((e: Error) => errorMessageHandler(e.message)))
